import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import DrawColor from '../../components/ExcerciseTypes/DrawColor';

const json = {
  1: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P45-E1',
    audio: 'img/FriendsPlus/Page45/Audio/audio-e1-p45.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page45/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page45/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page45/Audio/tieude-e1-p45.mp3' },
        { url: 'img/FriendsPlus/Page45/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page45/E1/4.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P31-E5',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page45/E2/1.jpg' }]],
  },
  3: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P45-E3',
    audio: '',
    video: '',
    component: DrawColor,
    exerciseKey: 'img/FriendsPlus/Page45/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Answer the questions. Then circle What and underline When.<br />Draw a square around Where.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: { width: 200, marginLeft: 20, color: '#00a8ec' },
        answers: ['', '', '', '', '', ''],
        initialValue: [],
      },
      Circle: {
        listStyle: {
          normal: {},
          circle: { padding: 3, border: 'solid 2px', borderRadius: '50%', borderColor: 'rgb(0, 168, 236)', color: '#c70927' },
          underline: { borderBottom: '2px solid gray', borderColor: 'rgb(0, 168, 236)', color: '#c70927' },
          square: { padding: 3, border: 'solid 2px', borderColor: 'rgb(0, 168, 236)', color: '#c70927' },
        },
        listWords: [
          'When do you get up?', //0
          'What do you do in the morning?', //1
          'Where|’s your school?', //2
          'When do you have dinner?', //3
          'What|’s your teacher’s name?', //4
          'When do you go to bed?', // 5
        ],
        answers: { '0-0': 'underline', '1-0': 'circle', '2-0': 'square', '3-0': 'underline', '4-0': 'circle', '5-0': 'underline' },
        initialValue: [],
      },
      Layout: `
        <div style='background-color: #fcf5bd; padding: 20px;'>
          <div><span style="border: 2px solid rgb(0, 168, 236);padding: 3px;border-radius: 50%; color: #c70927;">What</span> do you do in the morning?</div>
          <div><u style='text-decoration-color: #00a8ec; color: #c70927;'>When</u> do you get up?&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<span style="border: 2px solid rgb(0, 168, 236);padding: 3px; color: #c70927;">Where</span> do you go?</div>
          <div><span><b>1</b> <input id='0' type='Circle' /> I get up at <input id='0' /></span>.</div>
          <div><span><b>2</b> <input id='1' type='Circle' /> I have my <input id='1' /></span>.</div>
          <div><span><b>3</b> <input id='2' type='Circle' /> My school is <input id='2' /></span>.</div>
          <div><span><b>4</b> <input id='3' type='Circle' /> I have dinner at <input id='3' /></span>.</div>
          <div><span><b>5</b> <input id='4' type='Circle' /> My teacher’s name is <input id='4' /></span>.</div>
          <div><span><b>6</b> <input id='5' type='Circle' /> I go to bed at <input id='5' /></span>.</div>
        </div>
      `,
    },
  },
}

export default json;